export const ADD = 'ADD';
export const DEC = 'DEC';
export const INC = 'INC';
export const REM = 'REM';
export const TOT = 'TOT';
export const CLR = 'CLR';
export const CNT = 'CNT';
